// extracted by mini-css-extract-plugin
module.exports = {"grouping_count":"index_grouping_count_1Wh8v","right":"index_right_VOpYO"};